module.exports = __webpack_public_path__ + "static/google-play-badge-93051dee75af4ff526c7b51af9e13001.png";